/**
 * Labels for the PO / discount-code box (`PurchaseOrderDiscountCode.tsx`) in en / fr / es.
 * `%company%` in the legal text is replaced with the brand name by
 * `Checkout/Shared/Utility.functions.ts` → `replaceContentWithCompanyName`.
 */
import { LanguageContent } from "@ryerson/frontend.common";

/**
 * PO / discount-code labels. `discountApplied` doubles as a marker: the views render the
 * current message as a success alert when it equals this string, and as an error otherwise.
 */
export interface ShoppingCartPurchaseOrderText {
	discountCode: string;
	purchaseOrder: string;
	flexibleDates: string;
	apply: string;
	legalTextOne: string;
	legalTextLink: string;
	legalTextTwo: string;
	discountApplied: string;
	invalidDiscount: string;
}

/** PO / discount-code strings by language; the component falls back to `en`. */
export const ShoppingCartTableContent: LanguageContent<ShoppingCartPurchaseOrderText> = {
	en: {
		discountCode: "Use a Discount Code",
		purchaseOrder: "Purchase Order #",
		flexibleDates: "Flexible Shipping Dates (Select Flexible Delivery and receive a discount.)",
		apply: "Apply",
		legalTextOne: "The %company% ",
		legalTextLink: "Terms and Conditions of Sale ",
		legalTextTwo: "are applicable to all sales by %company%.",
		discountApplied: "Discount Applied",
		invalidDiscount: "Invalid discount code",
	},
	fr: {
		discountCode: "Utiliser un Code de Rabais",
		purchaseOrder: "Bon de Commande No",
		flexibleDates: "Dates d’expédition Flexibles",
		apply: "Appliquer",
		legalTextOne: "Le %company% ",
		legalTextLink: "Conditions générales de vente ",
		legalTextTwo: "s'appliquent à toutes les ventes par %company%.",
		discountApplied: "Rabais appliqué",
		invalidDiscount: "Code de rabais non valide",
	},
	es: {
		discountCode: "Usar un Código de Descuento",
		purchaseOrder: "Pedido N°",
		flexibleDates: "Fechas de Envío Flexibles",
		apply: "Aplicar",
		legalTextOne: "El %company% ",
		legalTextLink: "Términos y condiciones de venta ",
		legalTextTwo: "son aplicables a todas las ventas de %company%.",
		discountApplied: "Descuento aplicado",
		invalidDiscount: "Código de descuento no válido",
	},
};
